import { render, staticRenderFns } from "./showShortLink2.vue?vue&type=template&id=4b13c858&scoped=true"
import script from "./showShortLink2.vue?vue&type=script&lang=js"
export * from "./showShortLink2.vue?vue&type=script&lang=js"
import style0 from "./showShortLink2.vue?vue&type=style&index=0&id=4b13c858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13c858",
  null
  
)

export default component.exports